var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{attrs:{"type":"date","placeholder":"Pick a day"},on:{"change":_vm.updateField,"focus":function($event){return _vm.$emit("focus")}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }